import { useState, useEffect } from "react";
import appStoreBadge from "../assets/app-store-badge.svg";

export default function Hero({ onJoin }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Run once on mount + whenever the window resizes
    const checkIsMobile = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth <= 768);
      }
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // 💻 DESKTOP/TABLET — this is exactly what you had before
  const desktopVideoStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "100%",
    height: "auto",
    transform: "translate(-50%, -45%)",
    objectFit: "cover",
    zIndex: 0,
  };

  // 📱 MOBILE — reformatted to fill the top area better
  const mobileVideoStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "auto",
    height: "100%",
    transform: "translate(-50%, -40%)", // tweak this to move up/down on phones
    objectFit: "cover",
    zIndex: 0,
  };

  return (
    <section id="hero" style={{ position: "relative", overflow: "hidden" }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className="hero-bg-video"
        style={isMobile ? mobileVideoStyle : desktopVideoStyle}
      >
        <source src="/done_SDR.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
        <h2
          style={{
            fontSize: "4rem",
            fontWeight: "900",
            color: "#ffffffff",
            textAlign: "center",
            margin: "1.5rem 0",
            letterSpacing: "-1.2px",
            lineHeight: "1.05",
            textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)"
            // textShadow: `
            //   0 0 10px #213636ff,
            //   0 0 20px #faf9f9ff,
            //   0 0 35px #4c5a70ff
            // `,
          }}
        >
          Find Your Fitness Community
        </h2>

        <a
          href="https://apps.apple.com/app/apple-store/id6766742055?pt=128811910&ct=website&mt=8"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-app-store-badge"
        >
          <img
            src={appStoreBadge}
            alt="Download on the App Store"
            style={{ height: "58px", width: "auto" }}
          />
        </a>

        <p
          style={{
            marginTop: "1.2rem",
            fontSize: "1.2rem",
            fontWeight: "500",
            color: "#e2e8f0",
            textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          {/* Be the first to use the app! */}
        </p>
        <p
          style={{
            fontSize: "1.4rem",
            fontWeight: "700",
            color: "#a2c7e9",
            marginTop: "0.4rem",
            textTransform: "uppercase",
            letterSpacing: "1px",
            textShadow: `
        0 0 6px #394142ff,
        0 0 12px #3d92e0ff,
        0 0 18px #69b3f0ff
      `,
          }}
        >
        </p>
      </div>
    </section>
  );
}